import actions from './confirm-change-status-amenities-order.types';
import watch from './confirm-change-status-amenities-order.operations';
import reducer, { initState } from './confirm-change-status-amenities-order.reducers';

export { actions, watch, initState };

export default reducer;
